import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TablePagination,
} from "@mui/material";
import "./CustomerListView.scss";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { primaryColor } from "../../../constants/colorConstants";
import { useNavigate } from "react-router-dom";
import {
  getCustomerList,
  getCustomerCount,
} from "../../../services/srmService";
import moment from "moment";

export default function CustomerListView() {
  let [enableListView, setEnableListView] = useState(true);
  let [totalCount, setTotalCount] = useState(0);
  let [search, setSearch] = useState("");
  let [displayNoData, setDisplayNoData] = useState(true);
  let [loading, setLoading] = useState(true);
  let [isCheckBoxSelected, setIsCheckBoxSelected] = useState(false);
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };
  const navigate = useNavigate();

  const fetchCustomers = () => {
    setLoading(true);
    getCustomerList(controller.page, controller.limit, search).then((res) => {
      setRows(
        res.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            status: item.disabled ? "Inactive" : "Active",
            logo: item.logo,
            selected: false,
            last_sent: item.last_sent
              ? moment(new Date(item.last_sent)).format("D MMM YYYY")
              : "Never sent",
            dataRequest: item.next_date
              ? new Date(item.next_date) > new Date()
                ? "Submitted"
                : "Not Submitted"
              : "Not Submitted",
          };
        })
      );
      getCustomerCount().then((res) => {
        setTotalCount(res.data.count);
        if (res.data.count) {
          setDisplayNoData(false);
        }
      });
      setLoading(false);
    });
  };
  useEffect(() => {
    fetchCustomers();
  }, [controller.page, controller.limit, search]);

  const [rows, setRows] = useState(
    [] as {
      name: string;
      status: string;
      id: number;
      selected: boolean;
      logo: string;
      last_sent: string;
      dataRequest: string;
    }[]
  );

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const resetSelection = () => {
    setIsCheckBoxSelected(false);
    setSelectedRowIds([]);
    let tempRows = rows.map((row) => {
      row.selected = false;
      return row;
    });
    setRows([...tempRows]);
  };

  const handleNewClick = () => {
    console.log("opening creation screen");
    navigate("/partners/suppliers/create");
  };
  const [selectedRowIds, setSelectedRowIds] = useState<any[]>([]);
  const handleSingleCheckbox = (event: any, row: any, index: any) => {
    if (event.target.checked) {
      selectedRowIds.push(row.id);
    } else {
      let ind = selectedRowIds.findIndex((id) => id == row.id);
      selectedRowIds.splice(ind, 1);
    }
    const enableToggle = selectedRowIds.length > 0;
    rows[index].selected = event.target.checked;
    setIsCheckBoxSelected(enableToggle);
    setSelectedRowIds([...selectedRowIds]);
    setRows([...rows]);
  };
  const [activeId, setActiveId] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const openDetailedView = (id: any, index: any) => {
    // setEnableListView(false);
    // setActiveIndex(index);
    // setActiveId(id);
  };

  const onClose = () => {
    setEnableListView(true);
  };
  const prev = () => {
    if (activeIndex > 0) {
      setActiveId(rows[activeIndex - 1].id);
      setActiveIndex(activeIndex - 1);
    }
  };
  const openDataEntry = (id: any, index: any) => {
    navigate("/partners/customers/submit-data" + "?customer=" + id);
  };
  const next = () => {
    if (activeIndex + 1 < controller.limit) {
      setActiveId(rows[activeIndex + 1].id);
      setActiveIndex(activeIndex + 1);
    }
  };

  const cellColumns = [
    "",
    "Company Name",
    "Last Sent Date",
    "Status",
    "Data Request",
  ];

  return (
    <>
      {displayNoData ? (
        <div
          className="flex flex-row justify-center items-center text-2xl"
          style={{ height: "50vh" }}
        >
          No Data
        </div>
      ) : (
        <div className="flex flex-row relative">
          <Box
            className="pw-supplier-list"
            width={enableListView ? "100%" : "30%"}
            flexShrink={0}
            //bgcolor={enableListView ? "red" : "rgb(245 247 250)"}
          >
            <div
              className="mb-8"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "50px",
              }}
            >
              <OutlinedInput
                style={{
                  width: enableListView ? "20rem" : "12rem",
                  backgroundColor: "#FAFBFD",
                }}
                onChange={handleSearch}
                placeholder="Search"
                endAdornment={
                  <InputAdornment position="end">
                    {search === "" ? (
                      <IconButton edge="end">
                        <SearchIcon />
                      </IconButton>
                    ) : (
                      <IconButton edge="end">
                        <CloseIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                }
              />
              {/* {isCheckBoxSelected ?
              <div className="pw-check-options">
              </div>
              : <div style={{ color: "white", display: "flex" }}>
                <div onClick={handleNewClick} style={{ background: primaryColor, display: "flex", padding: "10px 20px", borderTopLeftRadius: "5px", alignItems: "center", cursor: "pointer", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", borderTopRightRadius: "5px" }}><AddBoxIcon className="pw-box-icon" sx={{ marginRight: 1 }} /> {t("New")}
                </div>

              </div>} */}
            </div>

            {enableListView ? (
              <TableContainer
                component={Paper}
                sx={{ height: "60vh", overflowY: "auto" }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead sx={{ backgroundColor: "#FAFBFD" }}>
                    <TableRow>
                      {cellColumns.map((eachCell, index) => (
                        <TableCell
                          key={index}
                          id={eachCell + "-th"}
                          style={{
                            border: "none",
                            color: "#596981",
                            fontSize: "14px",
                          }}
                        >
                          {eachCell.trim()}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.length ? (
                      rows.map((row, index) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            cursor: "pointer",
                          }}
                        >
                          <TableCell
                            onClick={() => openDetailedView(row.id, index)}
                            sx={{ width: "5vw" }}
                          >
                            <Avatar src={row.logo} />
                          </TableCell>
                          <TableCell
                            onClick={() => openDetailedView(row.id, index)}
                          >
                            {row.name}
                          </TableCell>
                          <TableCell
                            onClick={() => openDetailedView(row.id, index)}
                          >
                            {row.last_sent}
                          </TableCell>
                          <TableCell
                            onClick={() => openDetailedView(row.id, index)}
                          >
                            {row.status == "Active" ? (
                              <span
                                style={{ color: "#59CE90", fontWeight: "bold" }}
                              >
                                Active
                              </span>
                            ) : (
                              <span style={{ color: "#8897AE" }}>Inactive</span>
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() => openDataEntry(row.id, index)}
                          >
                            <Chip
                              label={row.dataRequest}
                              sx={{
                                cursor: "pointer",
                                backgroundColor:
                                  row.dataRequest == "Submitted"
                                    ? "#EEF6ED"
                                    : "#EAEEF4",
                                fontWeight: "bold",
                                color:
                                  row.dataRequest == "Submitted"
                                    ? "#70A268"
                                    : "#3D4A5C",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : loading ? (
                      <td colSpan={7} className="text-center">
                        Loading..
                      </td>
                    ) : (
                      <td colSpan={7} className="text-center">
                        No Data
                      </td>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <div className="flex flex-col gap-y-0.5">
                {rows.length ? (
                  rows.map((row, index) => (
                    <div
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          activeId == row.id ? "rgb(245, 247, 250)" : "white",
                      }}
                      onClick={() => openDetailedView(row.id, index)}
                      className="flex flex-row gap-x-3 items-center pw-bunitlist-card bg-white"
                    >
                      <Avatar src={row.logo} />
                      <div>
                        <div>{row.name}</div>
                      </div>
                    </div>
                  ))
                ) : loading ? (
                  <div className="text-center">Loading..</div>
                ) : (
                  <div className="text-center">No Data</div>
                )}
              </div>
            )}
            {totalCount > controller.limit ? (
              <TablePagination
                component="div"
                onPageChange={handlePageChange}
                page={controller.page}
                count={totalCount}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            ) : (
              ""
            )}
          </Box>
          {/* {enableListView ? "" : <SupplierDetailedView onNext={next} onPrev={prev} supplierId={activeId} onClose={onClose} />} */}
        </div>
      )}
    </>
  );
}
